import { render, staticRenderFns } from "./LogoLoader.vue?vue&type=template&id=f6847024&scoped=true&"
import script from "./LogoLoader.vue?vue&type=script&lang=js&"
export * from "./LogoLoader.vue?vue&type=script&lang=js&"
import style0 from "./LogoLoader.vue?vue&type=style&index=0&id=f6847024&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f6847024",
  null
  
)

export default component.exports